import { render, staticRenderFns } from "./DealCelebration.vue?vue&type=template&id=fe4e5742&"
import script from "./DealCelebration.vue?vue&type=script&lang=js&"
export * from "./DealCelebration.vue?vue&type=script&lang=js&"
import style0 from "./DealCelebration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports